/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-link.vue?vue&type=template&id=69503e33&scoped=true"
import script from "./j-link.vue?vue&type=script&lang=js"
export * from "./j-link.vue?vue&type=script&lang=js"
import style0 from "./j-link.vue?vue&type=style&index=0&id=69503e33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69503e33",
  null
  
)

export default component.exports